import callmike from "url:../../assets/wtrok/call-mike.png";

export function WTROKH() {
    return <div className="v-box center-all gap-32">
        <img className="width-640 height-auto" src={callmike} />
        <div className="v-box center-all">
            <div className="text-28 font-soon">ROCK and TALK around the CLOCK.</div>
            <br/>
            <div className="text-28 font-soon">We play THE Hits,</div>
            <div className="text-28 font-soon">the DEEPEST Cuts,</div>
            <div className="text-28 font-soon">the LEGENDS of the Local Scene,</div>
            <div className="text-28 font-soon">and EVERYTHING ELSE YOUR EARS WANT.</div>
            <div className="text-28 font-soon">YES, EVEN THAT!!</div>
            <div className="text-28 font-soon">OUR DISCS TO YOUR EARS!</div>
            <br/>
            <div className="text-28 font-soon">CALL 333-MIKE FOR REQUESTS!</div>
        </div>
        <div className="v-box font-treb center-all width-512 gap-8 text-18">
            <div>Check out our <a href="/wtrok/sweepstakes">Sweepstakes</a> page to learn about the DAILY Sweepstakes. Prizes prizes prizes!</div>
            <div>We are PROUD to be sponsored by BIG CORNER GASOLINE. Pull up to the BIG CORNER to gas up FAST. There's no gas station more convenient in all of Triple Oaks!</div>
        </div>
    </div>
}